import { render, staticRenderFns } from "./DefaultNotification.vue?vue&type=template&id=39783828&scoped=true&"
import script from "./DefaultNotification.vue?vue&type=script&lang=js&"
export * from "./DefaultNotification.vue?vue&type=script&lang=js&"
import style0 from "./DefaultNotification.vue?vue&type=style&index=0&id=39783828&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39783828",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VDialog,VIcon,VImg})
